export const inboxMassOfferingsFormNames = {
  agreeOnRegulations: 'agreeOnRegulations',
  email: 'email',
  fullName: 'full_name',
  offeringAmount: 'offering_amount',
  totalAmountToPay: 'total_amount_to_pay',
  offeringContent: 'offering_content',
  offeringType: 'offering_type',
  phone: 'phone',
  showAddress: 'show_address',
  city: 'city',
  street: 'street',
  zipCode: 'zip_code',
  country: 'country',
  userCoversServiceFee: 'service_fee_covered',
};
